import { TranslocoService } from '@ngneat/transloco';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss']
})
export class FormErrorComponent implements OnInit {

  @Input() control: UntypedFormControl = null;
  @Input() inline: boolean;
  @Input() label: string;

  constructor(
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  get errors(): string {
    if (this.control.invalid && this.control.errors) {
      const errors = [];
      for (const [key, value] of Object.entries(this.control.errors)) {
        switch (key) {
          case('required'): {
            if (value === true) {
              errors.push((this.label) ? this.label + this.transloco.translate('common.errors.is_mandatory') : this.transloco.translate('common.errors.mandatory'));
            }
            break;
          }
          case('email'): {
            errors.push(this.transloco.translate('common.errors.wrong_email'));
            break;
          }
          case('min'): {
            errors.push(this.transloco.translate('common.errors.min_value') + value.min);
            break;
          }
          case('max'): {
            errors.push(this.transloco.translate('common.errors.max_value') + value.max);
            break;
          }
          case('minMax'): {
            errors.push(this.transloco.translate('common.errors.max_min_value'));
            break;
          }
          case('passwordLength'): {
            errors.push(this.transloco.translate('common.errors.password_too_short'));
            break;
          }
          case('passwordStrength'): {
            errors.push(this.transloco.translate('common.errors.password_too_simple'));
            break;
          }
          case('passwordMatch'): {
            errors.push(this.transloco.translate('common.errors.password_match'));
            break;
          }
          default: {
            if (key.match(/backend/) && value.messages) {
              value.messages.forEach((message: string) => {
                errors.push(message);
              });
            } else if (this.label) {
              errors.push(this.label);
            } else {
              errors.push(this.transloco.translate('common.errors.unknown_error'));
            }
            break;
          }
        }
      }
      return errors.join('\n');
    }
    return '';
  }

}
